export default {
	borderRadius: 10,
	borderRadius_large: 20,
	fontSize_Small: 12,
	fontSize_Medium: 16,
	fontSize_Large: 20,
	fontSize_XLarge: 24,
	margin_XSmall: 5,
	margin_Small: 10,
	margin_Medium: 20,
	margin_Large: 30,
	marginHorizontal_XSmall: 5,
	marginHorizontal_Small: 10,
	marginHorizontal_Medium: 20,
	marginHorizontal_Large: 30,
	marginVertical_XSmall: 5,
	marginVertical_Small: 10,
	marginVertical_Medium: 20,
	marginVertical_Large: 30,
	padding_XSmall: 5,
	padding_Small: 10,
	padding_Medium: 20,
	padding_Large: 30,
	margin: 4,
	padding: 4,
	separatorHeight: 0.5,
	baseHeight: 10,
	baseWidth: 10,
};
